export default __webpack_public_path__ + "static/banner-sustainable-eco-friendly-home-renovations-3aea4d25c6b1114b47e14ff04bce6d5d.jpg";